import { render, staticRenderFns } from "./ReferOutsider.vue?vue&type=template&id=3180ebe6"
import script from "./ReferOutsider.vue?vue&type=script&lang=js"
export * from "./ReferOutsider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports